<div class="container" [ngClass]="{ readonly: ReadOnly == true }">
    <div class="row container-fluid claim-info-search" style="padding-top:0.3rem;">
        <div class="row claiminfo">Claims Information</div>
        <div class="row memberinfomsg">Please select one of the required fields below</div>
        <div class="search-field-container">
          <form>
            <div class="row">
                <div class="col-3">
                    <label class="search-field-label">Carrier Member ID</label>
                    <input type="text" name="carrier" class="search-field" [(ngModel)]="claimSearchData.CarrierMemberId">
                </div>
                <div class="col-3">
                    <label class="search-field-label">Claim ID</label>
                    <input type="text" name="claimid" class="search-field" [(ngModel)]="claimSearchData.ClaimId"/>
                </div>
                <div class="col-3">
                    <label class="search-field-label">Provider ID</label>
                    <input type="text" name="providerid" class="search-field" [(ngModel)]="claimSearchData.ProviderId">
                </div>
                <div class="col-3">
                    <label class="search-field-label">Provider NPI</label>
                    <input type="text" name="providernpi" class="search-field" [(ngModel)]="claimSearchData.ProviderNPI"/>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-3">
                    <label class="search-field-label">Start Date</label>
                    <input type="text" name="startdate" class="search-field" [(ngModel)]="claimSearchData.DateFrom">
                </div>
                <div class="col-3">
                    <label class="search-field-label">End Date</label>
                    <input type="text" name="enddate" class="search-field" [(ngModel)]="claimSearchData.DateTo">
                </div> -->
                <div class="col-3">
                  <label class="search-field-label">Start Date</label>
                  <p-calendar class="calender"
                  name="startdate"
                      [readonlyInput]="true"
                      [(ngModel)]="claimSearchData.DateFrom"
                      [iconDisplay]="'input'" 
                      [showIcon]="true" 
                      [maxDate]="maxdate"
                      placeholder="MM/DD/YYYY"
                      inputId="icondisplay" 
                      />
              </div>
              <div class="col-3">
                <label class="search-field-label">End Date</label>
                <p-calendar class="calender"
                name="enddate"
                    [readonlyInput]="true"
                    [(ngModel)]="claimSearchData.DateTo"
                    [iconDisplay]="'input'" 
                    [showIcon]="true" 
                    [maxDate]="maxdate"
                    placeholder="MM/DD/YYYY"
                    inputId="icondisplay" 
                    />
            </div>
            </div>
            <div class="row" style="padding-top:0.8rem;">
                <div class="col-1 col-serach">
                    <!-- <button class="btn-search" (click)="search()">Search</button> -->
                    <input class="btn-search" type="submit" value="Search" (click)="search()">
                </div>
                <div class="col">
                    <button class="clear-search" (click)="clearSearchResults()">Clear Search Results</button>
                </div>
            </div>
          </form>
        </div>
    </div>
    <div class="row container-fluid claim-information" *ngIf="showTabularData">
      <hr class="light-separator" />
      <label class="recordcount">{{claimData?claimData.length:0}} Records Found</label>
      <p-table [value]="claimData" [tableStyle]="{ 'min-width': '50rem' }"
      [(first)]="currentpage"
      [paginator]="true"
      [rows]="5"
      [totalRecords]="claimData?.length"
      (onRowSelect)="onRowSelect($event)"
      selectionMode="single"
      [scrollable]="true"
      (onPage)="onPageChange($event)"
      >
          <ng-template pTemplate="header">
              <tr>
                  <th>Carrier Mem ID</th>
                  <th>Claim ID</th>
                  <th>Member Full Name
                    <span class="sort" (click)="sortByName('MemberFullName')">
                      <ng-container *ngIf="sortOrder; else others">
                        <ng-container *ngIf="sortOrder=='Asc'; else falseBlock">
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                        </ng-container>
                        <ng-template #falseBlock>
                          <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                        </ng-template>
                      </ng-container>
    
                      <ng-template #others>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                      </ng-template>
                    </span>
                  </th>
                  <th>Provider NPI</th>
                  <th>Provider ID</th>
                  <th>Provider Full Name</th>
                  <th>Total Amount</th>
                  <th>Start Date</th>
                  <th>End Date</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-claimInfo>
              <tr [pSelectableRow]="claimInfo">
                  <td> {{claimInfo['CarrierMemId']}}</td>
                  <td>{{claimInfo['ClaimId']}} </td>
                  <td>{{claimInfo['MemberFullName']}} </td>
                  <td>{{claimInfo['ProviderNPI']}} </td>
                  <td>{{claimInfo['ProvId']}} </td>
                  <td>{{claimInfo['ProviderFullName']}} </td>
                  <td>{{claimInfo['TotalAmount']}} </td>
                  <td>{{claimInfo['StartDate']}} </td>
                  <td>{{claimInfo['EndDate']}} </td>
              </tr>
          </ng-template>
      </p-table>

    </div>
    <div class="row container-fluid claim-information" *ngIf="displayClaimInfo">
      <hr class="light-separator" />
      <a (click)="navBack()" class="navCont navback" *ngIf="claimData?.length>1"><pre class="navback arrow" >< </pre>Back</a>
      <label class="lbl-claims">{{ClaimMemberName?ClaimMemberName:''}}</label>
      <hr class="separator" />
      <!-- <form [formGroup]="dynamicForm" *ngIf="FieldsConf.Groups.length > 0"> -->
        <!-- <div *ngFor="let field of mappedDetails"> -->
          <div class="data-container">
          <div class="input-data" *ngFor="let kv of mappedDetails | keyvalue">
              <label class="info-label" for="{{ kv.key }}">{{ kv.key }}</label><br />
              <label class="info-value" for="{{ kv.value }}">{{ kv.value || '-'}}</label><br />
          </div> 
          </div>
        <!-- </div> -->
        
        
      <!-- </form> -->
    </div>
  </div>